module.exports = __webpack_public_path__ + "static/media/ic_作业_pr.940a4e6b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ic_作业_pr.svg
// module id = 202
// module chunks = 0